<template>
  <div class="bindCar">
    <div class="car_num_holder"></div>
    <carNum-input @getcarNumParent="getCarNum"></carNum-input>
    <van-button class="bt_qurey" color="#f47b20" @click="bindCar">确认绑定</van-button>
  </div>
</template>

<script>
  import {
    Dialog
  } from 'vant';
    import { mySessionStorage } from '@/utils/storage.js'
  export default {
    name: "bindCar",
    data() {
      return {
        adsenceImgUrl: "../static/img/adsence4.jpg",
        isBind: true,
        query: {
          openid: "",
          carNum: "",
        }
      };
    },
    methods: {
      onClickLeft() {
        console.log("返回");
        this.$router.push("/menu");
      },

      getCarNum(carNum) {
        this.query.carNum = carNum;
      },

      bindCar() {
        if (this.query.carNum == "") {
          Dialog.alert({
            message: "请完善车牌"
          });
          return
        }
        this.$http.post(this.$api.bindCar, {
          ...this.query
        }).then(res => {
          if (res.code == 202) {
            Dialog.confirm({
              title: '温馨提示',
              message: res.msg,
              confirmButtonText:"申诉"
            }).then(() => {
              this.$router.push({
                path: '/appeal',
                query: {
                  carNum: this.query.carNum
                }
              });
            }).catch(() => {});
          } else if (res.code == 203) {

            Dialog.alert({
              message: res.msg
            })
          } else {
            this.$router.push("/myCar");
          }
        });
      }

    },
    created() {
      this.query.openid=mySessionStorage.getItem("openid");
    }
  };
</script>

<style scoped>
  .bindCar {
    min-height: 100%;
    height: 100%;
    width: 100%;
    max-width: 100%;
    background-color: #e8e9eb;
    float: left;
  }

  .adsense_space {
    width: 100%;
    height: 25%;
  }

  .adsense_space img {
    height: 100%;
    width: 100%;
  }

  .nav_bar {
    width: 100%;
    height: 46px;
    float: left;
  }

  .car_num_holder {
    height: 40px;
    width: 100%;
    float: left;
  }

  .bt_qurey {
    width: 80%;
    margin-left: 10%;
    margin-top: 30px;
    border-radius: 5px;
    height: 36px;
    /* position: fixed;
  display: block; */
  }
</style>



// WEBPACK FOOTER //
// src/components/user/bind/bindCar.vue